import styled, { css } from "styled-components";
import { SearcherItem } from "../../../searcher/styled.js";
import { AddButton, ArrayInputRowContent, ArrayInputWrapper, RemoveIcon } from "../../../../../forms/inputs/array-input/styled.js";
import { ToggleInputWrapper, ToggleWrapper } from "../../../../../forms/inputs/toggle/styled.js";
import { FlexColumnMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const OpenjawInput = styled.div.withConfig({
    displayName: "styled__OpenjawInput",
    componentId: "sc-d791d4a6-0"
})`
	${AddButton} {
		position: initial;
		color: ${({ theme  })=>theme.colors.white.base};
		background: ${({ theme  })=>theme.colors.primary.base};
		border: 0;
		width: fit-content;
	}
	${AddButton}[disabled] {
		display: none;
	}
	${ArrayInputRowContent} {
		display: block;
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.base};
		padding-bottom: 16px;
		position: relative;
	}
	${RemoveIcon} {
		position: relative;
		display: flex;
		padding: 0;
		margin: 0;
		justify-content: flex-end;
		color: ${({ theme  })=>theme.colors.white.base};
	}
	${RemoveIcon}[disabled] {
		display: none;
	}
	${ArrayInputWrapper} {
		padding-bottom: 0px;
	}
	#location {
		margin-bottom: 16px;
	}
`;
export const SearcherFliItem = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherFliItem",
    componentId: "sc-d791d4a6-1"
})`
	${({ theme , $isOpenjaw  })=>$isOpenjaw ? css`
					${theme.media.up('sm')} {
						${FlexColumnMixin({
        columns: 2,
        gap: 'var(--division-gap)'
    })};
					}

					${theme.media.up('md')} {
						flex-basis: calc(((100% - 224px) / 4) - var(--division-gap));
						flex-grow: 1;
						max-width: unset;
					}

					${theme.media.up('lg')} {
						flex-grow: 1;
						flex-shrink: 0;
					}

					${theme.media.up('xl')} {
						flex-grow: 0;
					}
			  ` : ''}
	${({ $isToggle  })=>$isToggle ? css`
					display: flex;
			  ` : ''}
	${ToggleWrapper} {
		flex-direction: row-reverse;
		${ToggleInputWrapper} {
			margin-right: 10px;
		}
	}
`;
export const FlightLabel = styled.div.withConfig({
    displayName: "styled__FlightLabel",
    componentId: "sc-d791d4a6-2"
})`
	margin-bottom: 6px;
	color: ${({ theme  })=>theme.colors.white.base};
`;

//# sourceMappingURL=styled.js.map